export var competences = [
  ['Wireshark', 4],
  ['CUDA', 1],
  ['AXI', 5],
  ['Linux', 10],
  ['NTP', 2],
  ['FPGA', 9],
  ['C++', 6],
  ['Python', 5],
  ['C', 10],
  ['Android', 3],
  ['GIT', 7],
  ['LaTeX', 6],
  ['GPS', 5],
  ['VHDL', 8],
  ['Lua', 2],
  ['Yocto', 8],
  ['Javascript', 3],
  ['make', 5],
  ['RTK', 1],
  ['SolidWorks', 3],
  ['C#', 7],
  ['CAN', 6],
  ['EtherCAT', 2],
  ['tcl', 6],
  ['audio', 1],
  ['PTP', 4],
  ['SPI', 5],
  ['FreeRTOS', 1],
  ['CI/CD', 7],
  ['video', 4],
  ['Ruby', 1],
  ['HDL Designer', 3],
  ['PCIe', 3],
  ['Cmake', 4],
  ['Doxygen', 5],
  ['OpenCV', 1],
  ['Qt', 1]
];
